(function (root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD
    define(['torso/modules/NestedModel', 'torso/modules/mixins/loadingMixin', 'app/urls'], factory);
  } else if (typeof exports === 'object') {
    // Node, CommonJS-like
    module.exports = factory(require('backbone-torso/modules/NestedModel'), require('backbone-torso/modules/mixins/loadingMixin'), require('./../urls'));
  } else {
    throw 'Only AMD and CommonJS imports are supported.';
  }
}(this, function (TorsoNestedModel, loadingMixin, urls) {
  'use strict';

  /**
   * Model for appointment configuration information. Uses the AppointmentConfigurationService and corresponds to an AppointmentConfiguration
   *
   * @class AppointmentConfigurationModel
   * @extends Torso.NestedModel
   * @constructor
   */
  var AppointmentConfigurationModel = TorsoNestedModel.extend({
    urlRoot: urls.appointmentConfigurationExtService,

    /**
     * Extends the loadingMixin's methods with a method that both fetches (if not already fetched or fetching) and
     * returns a promise that will resolve once the fetch completes (or immediately if already fetched).
     * @returns {$.Deferred.Promise}
     */
    loadOnce: function () {
      if (!this.loadedOnce && !this.loading) {
        this.fetch(arguments);
      } else {
        this.trigger('load-complete');
      }
      return this.getLoadedOncePromise();
    }
  });

  AppointmentConfigurationModel = AppointmentConfigurationModel.extend(loadingMixin(AppointmentConfigurationModel));

  return new AppointmentConfigurationModel();
}));
